const recentlyPrd = (function () {
  return {
    init: function () {
      this.recently();
    },
    recently: function () {
      const dataProductLocalStorage = JSON.parse(localStorage.getItem("recently_product"))
      const recentlyProductMain = document.getElementById('recently-product__main')
      if (dataProductLocalStorage && recentlyProductMain) {
        const _this = this;
        dataProductLocalStorage.forEach((itemProduct, index) => {
          var handle = Object.values(itemProduct)
          var productHandleTemplateUrl = '/products/' + handle + '?view=card';
          if (index > 0) {
            _this.fetctProductWithHandle(productHandleTemplateUrl);
          }
        });
      }
    },
    fetctProductWithHandle: function (productHandleTemplateUrl) {
      const _this = this;
      const recentlyProductMain = document.getElementById('recently-product__main')
      const parser = new DOMParser();
      fetch(productHandleTemplateUrl)
        .then(response => response.text())
        .then(function (data) {
          const docProduct = parser.parseFromString(data, "text/html");
          const cardWrapper = docProduct.querySelector('.tp-prd-item');
          const gridItem = document.createElement('div')
          gridItem.setAttribute('class', 'swiper-slide')
          recentlyProductMain.appendChild(gridItem)
          if (gridItem.getAttribute('class') === 'swiper-slide' && cardWrapper) {
            gridItem.appendChild(cardWrapper)
          }
          recentlyProductMain.closest('.tp-prd-recom').classList.remove('hidden');
          _this.swiperRecentlyPrd();
        });
    },
    swiperRecentlyPrd: function () {
      const tpPrdRecently = document.querySelector('.js-tp-prd-recently');
      const spaceBetween = Number(tpPrdRecently.dataset.spaceBetween);
      const slidesPerView = Number(tpPrdRecently.dataset.desktop);
      const loop = tpPrdRecently.dataset.loop === "true";
      const autoplay = tpPrdRecently.dataset.autoplay === "true";
      var swpRecently = new Swiper(".js-tp-prd-recently", {
        spaceBetween: 15,
        slidesPerView: 1.5,
        slidesPerGroup: 1.5,
        loop: loop,
        autoplay: autoplay,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-next-prd-recently",
          prevEl: ".swiper-prev-prd-recently",
        },
        pagination: {
          clickable: true,
          el: ".swiper-pagination-prd-recently",
        },
        breakpoints: {
          410: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1025: {
            slidesPerView: slidesPerView,
            slidesPerGroup: slidesPerView,
            spaceBetween: spaceBetween
          }

        },
      });
    }
  }
})()
document.addEventListener("DOMContentLoaded", function () {
  recentlyPrd.init()
})

document.addEventListener("shopify:section:load", recentlyPrd);
document.addEventListener("shopify:section:unload", recentlyPrd);





